window.SMTX.Transcription = (function () {

  if ($('.PlaceInstantOrder-transcription').length < 1) {
    return false;
  }


  var API_BASE = '/api/v2';
  var SOURCE_TYPE_VIDEO = 'video';
  var SOURCE_TYPE_AUDIO = 'audio';
  var SERVICE_TRANSCRIPTION = 'transcription';
  var SERVICE_SUBTITLING = 'subtitling';
  var PACKAGE_LABELS = {
    premium: "Premium package",
    pro: "Professional package",
    economy: "Economy package",
  };
  var loader = {
    message: '<img src="/static/icons/spinner.svg" class="blockUI__spinner fixed-center" width="64" height="64" />',
    centerY: false,
    centerX: false,
    css: {
      position: 'fixed',
      margin: 'auto'
    },
    overlayCSS: {
      background: '#fff',
      opacity: 0.6
    }
  };
  var calcDate; // Used for time comparison when loading calculations
  var calcMinTime = 3000; // Minimum time in milliseconds for calcLoader to be displayed
  // Specific calculation Loader
  var calcLoader = {
    message: '<div class="blockUI__calculation fixed-center">' +
      '<img src="/static/images/iq_calculating_loader.gif" class="blockUI__calculation__image" width="600" height="600" />' +
      '<p class=blockUI__calculation__text">' + window.SMTX.TranscriptionSettings.calculating_price_loader_text + '</p>' +
      '</div>',
    centerY: false,
    centerX: false,
    css: {
      position: 'fixed',
      margin: 'auto'
    },
    overlayCSS: {
      background: '#fff',
      opacity: 1
    },
  };

  var quoteData = {
    email: null,
    country_code: window.SMTX.iq.country_code,
    leadId: null,
    subject: null,
    service: [],
    source_type: SOURCE_TYPE_VIDEO,
    source_url_video: "",
    source_files_video: 0,
    source_url_audio: "",
    source_files_audio: 0,
    fromLang: window.SMTX.iq.default_from_lang_id,
    toLang: [],
    uploadedFiles: [],
    calculatedQuote: null,
  };

  var languages = null;
  var languageTags = [];
  var languageToTagify;

  var blockUI = function (settings) {
    $.blockUI(settings);
  };

  var unblockUI = function () {
    $.unblockUI();
  };

  window.blockUI = blockUI;

  /*********************************
  
      API CALLS
  
  *********************************/

  var apiCalls = {
    getLanguages: function () {
      $.get(API_BASE + '/language?country_code=' + window.SMTX.iq.country_code, {}, apiCallbacks.languagesLoaded);
    },
    // Get Subjects for Step2
    getSubjects: function () {
      $.get(API_BASE + '/subject?country_code=' + window.SMTX.iq.country_code, {}, apiCallbacks.subjectsLoaded);
    },
    postLead: function () {
      $.ajax({
        type: "POST",
        dataType: "json",
        url: API_BASE + "/lead",
        data: {
          email: $('#quote_email_form input[name="email"]').val(),
          country_code: quoteData.country_code
        },
        success: apiCallbacks.leadPosted
      });
    },
    postFiles: function (fileUploadData) {
      $.ajax({
        url: API_BASE + '/files',
        type: 'POST',
        data: fileUploadData,
        cache: false,
        contentType: false,
        enctype: 'multipart/form-data',
        processData: false,
        //error: step2.fileUploadError,
        success: apiCallbacks.fileUploaded
      });
    },

    postQuote: function () {
      var qData = prepareQuoteData();
      $.ajax({
        type: "POST",
        dataType: "json",
        url: API_BASE + "/lead/" + quoteData.leadId + "/quote",
        data: qData,
        success: apiCallbacks.quotePosted
      });
    },

    putQuote: function () {
      var qData = {};
      qData['agreed'] = 1;
      qData['package'] = PACKAGE_LABELS.pro;

      if ($('.order-package input.switch-input').is(":checked")) {
        qData['express'] = 1;
      }

      $.ajax({
        type: "PUT",
        dataType: "json",
        url: API_BASE + "/lead/" + quoteData.leadId + "/quote/" + quoteData.calculatedQuote.id,
        data: qData,
        success: apiCallbacks.quotePut
      });
    },

    putOrder: function () {
      var oData = prepareOrderData();
      $.ajax({
        type: "PUT",
        dataType: "json",
        url: API_BASE + "/lead/" + quoteData.leadId,
        data: oData,
        success: apiCallbacks.orderPut
      });
    },

  };

  /*********************************
  
    API CALLBACKS
  
  *********************************/

  var apiCallbacks = {
    // Step1 - Load all languages
    languagesLoaded: function (e) {
      // Set global data
      //log(e);
      if (!languages) {
        languages = e;
      } else {
        unblockUI();
        return false;
      }


      // Populate to select box
      $('select#quote-from-language').html('');

      // Loop all languages
      for (var i = 0, il = languages.length; i < il; i++) {
        // Create language nodes
        $('select#quote-from-language').append(
          '<option value="' + languages[i].id + '"' +
          // Check Swedish by default if no module language data exists, otherwise select the correct from-language
          (((languages[i].code == "sv-SE" && quoteData.fromLang === undefined) || (quoteData.fromLang !== undefined && languages[i].id == quoteData.fromLang)) ? ' selected="selected"' : '') + '>' + // Preselect Swedish
          languages[i].name + // Name visible in dropdown
          '</option>');

        // Setup to-language - Populate languageTags with correct format
        languageTags.push({
          code: languages[i].code,
          id: languages[i].id,
          name: languages[i].name, // Keep original naming in case other value is used
          value: languages[i].name
        });
      }

      // Add language tags to tagify
      languageToTagify.settings.whitelist = languageTags;
      languageToTagify.settings.enforceWhitelist = true; // Only allow language tags, no text-tags

      transEvents.onLanguageChoosen();
      unblockUI();
    },

    subjectsLoaded: function (e) {
      subjects = e;
      // Populate to select box
      $('select#quote-subject').html('');
      $('select#quote-subject').append('<option value="" disabled selected>' + window.SMTX.TranscriptionSettings.choose_subject_placeholder + '</option>');
      // Loop subjects
      for (var i = 0, il = subjects.length; i < il; i++) {
        // Create and add subjects to select box
        $('select#quote-subject').append(
          '<option value="' + subjects[i].id + '">' +
          subjects[i].name + // Name visible in dropdown
          '</option>');
      }
      transStates.state01.init();
    },

    leadPosted: function (e) {
      lead = e;
      if (lead.id) {
        quoteData.leadId = lead.id;
        transStates.state01.showMainForm();

      } else {
        log('No id : lead posted');
      }
      // Populate to select box
      unblockUI();
    },

    fileUploaded: function (e) {
      //log('file(s) uploaded');
      //log(typeof e);
      //log(e);

      var resp;
      if (typeof e === 'string') {
        resp = JSON.parse(e);
      } else {
        resp = e;
      }

      if (resp.ids && resp.ids.length) {
        //log(resp.ids);
        quoteData.uploadedFiles = resp.ids;
      }
      apiCalls.postQuote();
    },

    quotePosted: function (e) {
      //log('quote posted');
      //log(e);
      quoteData.calculatedQuote = null;
      var resp = e;
      if (resp.packages) {
        quoteData.calculatedQuote = resp;
        transStates.state03.showPrices();
      } else if (resp.message) {
        // skip step 3, no price packages
        transStates.state04.initWithMessage(resp.message);
      } else {
        alert('something went wrong');
      }

    },
    quotePut: function (e) {
     // log('Quote accepted');
      // TODO no callback from API ??
      transStates.state04.init();
    },

    orderPut: function (e) {
      //log('Order confirmed');
      // TODO no callback from API ??
      transStates.state05.init();
    }

  };

  /*********************************
  
    STEPS / STATES
  
  *********************************/

  var transStates = {
    state01: {
      init: function () {
        unblockUI();
        showStep('1');
        //log('state 01');
      },
      showMainForm: function () {

        //log("quotedata");
        //log(quoteData);
        // save to pardot
        var formHandler;
        var data;
        if(window.SMTX.PardotTracker){
          formHandler = "l/848143/2021-04-01/p4vsn";
          data = {
            email: quoteData.email,
            Marketing_Language: window.SMTX.TranscriptionSettings.pardot_marketing_language,
            Instant_Quote_Product_Interest: "Multimedia"
          };
          window.SMTX.PardotTracker.track(formHandler, data);
        }

        $('[data-transcription-step="1"] .main-form').removeClass('inactive');
        scrollToPos($('[data-transcription-step="1"] .main-form').offset().top - 64);
      }
    },

    state02: {
      init: function () {
        blockUI(loader);
        apiCalls.getLanguages();
        //show or hide to languages
        if (quoteData.service.indexOf(SERVICE_SUBTITLING) >= 0) {
          $('[data-to-language]').removeClass('hide');
        } else {
          $('[data-to-language]').addClass('hide');
        }
        showStep('2');
      }

    },

    state03: {
      init: function () {
        blockUI(calcLoader);
        transEvents.uploadFilesAndGetQuote();
        showStep('3');
      },
      showPrices: function () {

        // set prices/delivery
        var currency_iso = quoteData.calculatedQuote.currency.iso;
        $('.order-package__price').addClass('hide');
        $('.order-package__price[data-delivery-price="general"]').text(formatPrice(quoteData.calculatedQuote.packages[PACKAGE_LABELS.pro].general.price, currency_iso));
        $('.order-package__price[data-delivery-price="express"]').text(formatPrice(quoteData.calculatedQuote.packages[PACKAGE_LABELS.pro].express.price, currency_iso));
        $('.order-package__price[data-delivery-price="general"]').removeClass('hide');

        $('.order-package__currency').text(currency_iso);
        $('.order-package__express-delivery__days').text(quoteData.calculatedQuote.packages[PACKAGE_LABELS.pro].express.days_to_end);
        $('.order-package__default-delivery__days').text(quoteData.calculatedQuote.packages[PACKAGE_LABELS.pro].general.days_to_end);

        //$('.order-package input.switch-input').prop('checked', false);
        $('.order-package input.switch-input').trigger('change');

        // set label and text 
        $('.order-package__name[data-package]').addClass('hide');
        $('.order-package__text[data-package]').addClass('hide');

        if (quoteData.service.indexOf(SERVICE_TRANSCRIPTION) >= 0 && quoteData.service.indexOf(SERVICE_SUBTITLING) >= 0) {
          $('.order-package__name[data-package="transcription+subtitling"]').removeClass('hide');
          $('.order-package__text[data-package="transcription+subtitling"]').removeClass('hide');
        } else if (quoteData.service.indexOf(SERVICE_TRANSCRIPTION) >= 0) {
          $('.order-package__name[data-package="transcription"]').removeClass('hide');
          $('.order-package__text[data-package="transcription"]').removeClass('hide');
        } else if (quoteData.service.indexOf(SERVICE_SUBTITLING) >= 0) {
          $('.order-package__name[data-package="subtitling"]').removeClass('hide');
          $('.order-package__text[data-package="subtitling"]').removeClass('hide');
        }
        //blockUI(calcLoader);
        //transEvents.uploadFilesAndGetQuote();
        setTimeout(function () {
          unblockUI();
        }, 1000);
      },
      acceptQuote: function () {
        blockUI(loader);
        apiCalls.putQuote();
      }
    },

    state04: {
      // edit dynamic texts
      init: function () {
        $('form.user_details input[name="email"]').val(quoteData.email);
        //log("email: " + quoteData.email);
        $('[data-quote-message]').text('');
        $('.PlaceInstantOrder__order').removeClass('has-message');
        setSummaryMenu();
        showStep('4');
        setTimeout(function () {
          unblockUI();
        }, 600);
      },
      initWithMessage: function (msg) {
        $('form.user_details input[name="email"]').val(quoteData.email);
        //log("email: " + quoteData.email);
        $('[data-quote-message]').text(msg);
        $('.PlaceInstantOrder__order').addClass('has-message');
        setSummaryMenu();
        showStep('4');
        setTimeout(function () {
          unblockUI();
        }, 1000);
      },
      submitOrder: function () {
        blockUI(loader);
        apiCalls.putOrder();
      },
    },

    state05: {
      // edit dynamic texts
      init: function () {
        
        setTimeout(function () {
          unblockUI();
        }, 1000);
        $('.StepsMenu--main').removeClass('StepsMenu--show');

        var formHandler;
        var data;
        var newsletter = ($('form.user_details input[name="newsletter_signup"]').is(":checked")) ? true : "";
        var productInterest = quoteData.service;

        for(var i = 0; i < productInterest.length; i++){
          productInterest[i] = capitalizeFirstLetter(productInterest[i]);
        }

        productInterest = productInterest.join(', ');

        if(window.SMTX.PardotTracker){
          formHandler = "l/848143/2021-04-01/p4vsn";
          data = {
            email: quoteData.email,
            Marketing_Language: window.SMTX.TranscriptionSettings.pardot_marketing_language,
            Instant_Quote_Product_Interest: productInterest,
            Has_Ordered: true,
            GDPR_Newsletter: newsletter,
          };
          window.SMTX.PardotTracker.track(formHandler, data);
        }

        showStep('5');
      }
    },
  };

  function showStep(step) {
    $('[data-transcription-step]').removeClass('is-active');
    $('[data-transcription-step="' + step + '"]').addClass('is-active');
    setStepsMenu(step);
    scrollToPos(0);
  }

  function setStepsMenu(step) {
    $('.StepsMenu__link[data-step]', '.StepsMenu').removeClass('StepsMenu__link--completed StepsMenu__link--active');

    var l = parseInt(step);
    for (var i = 1; i < l; i++) {
      $('.StepsMenu__link[data-step="' + i + '"]', '.StepsMenu').addClass('StepsMenu__link--completed');
    }

    $('.StepsMenu__link[data-step="' + step + '"]', '.StepsMenu').addClass('StepsMenu__link--active');

    // hide top menu if step >= 4
    if (step >= 4) {
      $('.StepsMenu').first().addClass('hide');
    } else {
      $('.StepsMenu').first().removeClass('hide');
    }

  }

  var transEvents = {
    onGoToStepClicked: function (e) {
      var $me = $(e.target);
      var targetStep = $me.data('go-to-step') + "";
    //  log('goto step ' + targetStep);

      switch (targetStep) {
        case "1":
          transStates.state01.init();
          break;
        case "2":
          transStates.state02.init();
          break;
        case "3":
          transStates.state03.init();
          break;
        case "4":
          transStates.state04.init();
          break;
        default:
          break;
      }
      e.preventDefault();

    },

    onLeadSubmit: function (e) {
      quoteData.email = $('#quote_email_form input[name="email"]').val();
      apiCalls.postLead();
      e.preventDefault();
      return false;
    },

    onSubjectChange: function (e) {
      quoteData.subject = $('#quote-subject').val();
      transEvents.validateFileForm();
    },

    onVideoSrcChange: function (e) {
      if( !isValidFileSize($('#quote-upload-video-files')) ){
        $('#quote-upload-video-files').val('');
      }
      quoteData.source_files_video = $('input#quote-upload-video-files').prop('files').length;
      transEvents.validateFileForm();
    },

    onAudioSrcChange: function (e) {
      if( !isValidFileSize($('#quote-upload-audio-files')) ){
        $('#quote-upload-audio-files').val('');
      }
      quoteData.source_files_audio = $('input#quote-upload-audio-files').prop('files').length;
      transEvents.validateFileForm();
    },

    onVideoUrlChange: function (e) {
      quoteData.source_url_video = $('input#quote-video-file-url').val();
      transEvents.validateFileForm();
    },

    onAudioUrlChange: function (e) {
      quoteData.source_url_audio = $('input#quote-audio-file-url').val();
      transEvents.validateFileForm();
    },

    onLanguageChoosen: function (e) {
      // Check if we have any languages chosen
      //log('on lang choosen');
      quoteData.fromLang = $('select#quote-from-language').val();
      quoteData.toLang = [];

      // Format language tags
      for (var i = 0, il = languageToTagify.value.length; i < il; i++) {
        quoteData.toLang.push(languageToTagify.value[i].id);
      }

      transEvents.validateLanguageForm();
      // Update language menu
      // updateMenu('fromLang', quoteLead.fromLang);
      // updateMenu('toLang', quoteLead.toLang);
    },

    onDeliveryTimeChange: function () {
      if ($('.order-package input.switch-input').is(":checked")) {
        $('.order-package__price[data-delivery-price="general"]').addClass('hide');
        $('.order-package__price[data-delivery-price="express"]').removeClass('hide');
      } else {
        $('.order-package__price[data-delivery-price="express"]').addClass('hide');
        $('.order-package__price[data-delivery-price="general"]').removeClass('hide');

      }
    },

    uploadFilesAndGetQuote: function () {

      var quoteFiles;
      var fileUploadData;
      quoteData.uploadedFiles = [];

      if (quoteData.source_type === SOURCE_TYPE_VIDEO && quoteData.source_files_video > 0) {
        // is video and has file(s)
        //log('is video and has file(s)');
        quoteFiles = $('input#quote-upload-video-files').prop('files');
        if (quoteFiles.length) {
          //log('uploading video files');
          fileUploadData = new FormData($('form.upload_file_form.video')[0]);
          apiCalls.postFiles(fileUploadData);
        }
        // apiCalls.uploadFile();

      } else if (quoteData.source_type === SOURCE_TYPE_AUDIO && quoteData.source_files_audio > 0) {
        // is audio and file(s)
        //log('is audio and has file(s)');
        quoteFiles = $('input#quote-upload-audio-files').prop('files');
        if (quoteFiles.length) {
          //log('uploading video files');
          var fileUploadData = new FormData($('form.upload_file_form.audio')[0]);
          apiCalls.postFiles(fileUploadData);
        }

      } else {
        //log('no file, get quote');
        apiCalls.postQuote();

      }
    },

    validateFileForm: function (e) {
      quoteData.source_type = getSourceType();
      var is_valid = true;

      // check subject 
      if (!quoteData.subject) {
        //log('No subject');
        is_valid = false;
      }

      quoteData.service = [];

      //set service type
      if (quoteData.source_type === SOURCE_TYPE_VIDEO) {
        $('[data-transcription-step="1"] .tabs-panel.is-active input[name="typeOfService"]:checked').each(function () {
          quoteData.service.push($(this).val());
        });
      } else {
        quoteData.service.push(SERVICE_TRANSCRIPTION);
      }

      if (quoteData.service.length === 0) {
        //log('No service choosen');
        is_valid = false;
      }

      //validate file and terms service type
      if (quoteData.source_type === SOURCE_TYPE_VIDEO && (!isValidVideoSource() || !$('#videoTermsCheckbox').is(":checked"))) {
        //log('Video but no src');
        is_valid = false;
      } else if (quoteData.source_type === SOURCE_TYPE_AUDIO && (!isValidAudioSource() || !$('#audioTermsCheckbox').is(":checked"))) {
        //log('Audio but no src');
        is_valid = false;

      } else if (!quoteData.source_type) {
        //log('No src type');
        is_valid = false;
      }

      checkDisableOtherSrc();

      if (is_valid) {
        //log('file form valid');
        //activate button
        $('[data-transcription-step="1"] .tabs-panel.is-active button[data-go-to-step]').removeClass('button--inactive');

      } else {
        //log('file form not valid');
        $('[data-transcription-step="1"] .tabs-panel.is-active button[data-go-to-step]').addClass('button--inactive');
        //de active button
      }

    },

    validateLanguageForm: function (e) {
      // Toggle button if languages exist
      //show or hide to languages
      if (quoteData.service.indexOf(SERVICE_SUBTITLING) >= 0) {
        if (quoteData.fromLang.length && quoteData.toLang.length) {
          //log('lang form valid');
          $('[data-transcription-step="2"] button[data-go-to-step]').removeClass('button--inactive');
        } else {
          //log('lang form not valid');
          $('[data-transcription-step="2"] button[data-go-to-step]').addClass('button--inactive');
        }
      } else {
        if (quoteData.fromLang.length) {
          //log('lang form valid');
          $('[data-transcription-step="2"] button[data-go-to-step]').removeClass('button--inactive');
        } else {
          //log('lang form not valid');
          $('[data-transcription-step="2"] button[data-go-to-step]').addClass('button--inactive');
        }
      }
    },

    validateOrderForm: function (e) {
      $('form.user_details').foundation('validateForm');
      // Check if any fields are invalid
      if ($('.is-invalid-input', 'form.user_details').length) {
        return false;
      }
      transStates.state04.submitOrder();
      e.preventDefault();
      return false;

    },

    onQuoteAccept: function () {
      transStates.state03.acceptQuote();
    }
  };

  /*********************************
  
    Runtime
  
  *********************************/

  // Step 01

  // Email lead
  $('#quote_email_form').submit(transEvents.onLeadSubmit);

  // File form
  $('#quote-subject').change(transEvents.onSubjectChange);
  $('#quote-subject').change(transEvents.onSubjectChange);

  $('input#quote-upload-video-files').on('change', transEvents.onVideoSrcChange);
  $('input#quote-upload-audio-files').on('change', transEvents.onAudioSrcChange);

  $('input#quote-video-file-url').on('change', transEvents.onVideoUrlChange);
  $('input#quote-audio-file-url').on('change', transEvents.onAudioUrlChange);

  $('input#videoTermsCheckbox').on('change', transEvents.validateFileForm);
  $('input#audioTermsCheckbox').on('change', transEvents.validateFileForm);

  $('input[name="typeOfService"]').on('change', transEvents.validateFileForm);

  $('[data-go-to-step]').on('click', transEvents.onGoToStepClicked);
  $('[data-put-order]').on('click', transEvents.validateOrderForm);
  $('[data-accept-quote]').on('click', transEvents.onQuoteAccept);

  $('.order-package input.switch-input').on('change', transEvents.onDeliveryTimeChange);

  // Language form
  var tagifyOptions = {
    whitelist: [], // Is populated in languagesLoaded
    dropdown: {
      enabled: 0, // Shows dropdown instantly
      maxItems: 300, // Show all languages in dropdown
    },
    skipInvalid: true, // Don't show invalid tags
    delimiters: ";", // Comma causes issues, use semicolon instead
  };

  languageToTagify = new Tagify($('input#quote-to-language')[0], tagifyOptions);
  languageToTagify.on('add', transEvents.onLanguageChoosen);
  languageToTagify.on('remove', transEvents.onLanguageChoosen);
  languageToTagify.on('edit', transEvents.onLanguageChoosen);
  languageToTagify.on('click', transEvents.onLanguageChoosen);
  languageToTagify.on('blur', transEvents.onLanguageChoosen);
  $('select#quote-from-language').on('change', transEvents.onLanguageChoosen);

  // $('body').on('click', function () {
  //   log('DATA:');
  //   log(quoteData);
  // });


  /*********************************
  
  Helpers
  
  *********************************/

  function setSummaryMenu() {
    var summary_src,
      summary_lang_from,
      summary_lang_to,
      summary_quote;

    // step 1 summary
    var src_text = "", tmpArr = [], l = quoteData.uploadedFiles.length;

    if (quoteData.uploadedFiles.length > 0) {
      for (var i = 0; i < l; i++) {
        tmpArr.push(Object.values(quoteData.uploadedFiles[i])[0]);
      }
      src_text = tmpArr.join(', ');
    } else if (quoteData.source_type === SOURCE_TYPE_VIDEO) {
      src_text = quoteData.source_url_video;
    } else {
      src_text = quoteData.source_url_audio;
    }
    summary_src = capitalizeFirstLetter(quoteData.source_type) + ' - ' + src_text;

    // step 2 lang
    summary_lang_from = getLanguageName(parseInt(quoteData.fromLang));

    l = quoteData.toLang.length;
    if (l > 0) {
      tmpArr = [];
      for (var i = 0; i < l; i++) {
        tmpArr.push(getLanguageName(quoteData.toLang[i]));
      }
      summary_lang_to = tmpArr.join(', ');
    } else {
      // is transcription only, same lang???
      summary_lang_to = summary_lang_from;
    }



    // step 3 quote
    summary_quote = "-";

    if (quoteData.calculatedQuote && quoteData.calculatedQuote.packages) {
      // TODO get translation (Package label)
      var currency_iso = quoteData.calculatedQuote.currency.iso;
      summary_quote = capitalizeFirstLetter(quoteData.service.join(','));
      if ($('.order-package input.switch-input').is(":checked")) {
        // is express
        summary_quote += ' - Express - ' + formatPrice(quoteData.calculatedQuote.packages[PACKAGE_LABELS.pro].express.price, currency_iso) + currency_iso;
      } else {
        // is standars/general
        summary_quote += ' - ' + formatPrice(quoteData.calculatedQuote.packages[PACKAGE_LABELS.pro].general.price, currency_iso) + currency_iso;
      }
    }

    // set text fields
    $('[data-summary="source"]').text(summary_src);
    $('[data-summary="lang-from"]').text(summary_lang_from);
    $('[data-summary="lang-to"]').text(summary_lang_to);
    $('[data-summary="quote"]').text(summary_quote);

  }

  function getLanguageName(val) {
    for (var i = 0, il = languages.length; i < il; i++) {
      if (languages[i].id == val) {
        return languages[i].name;
      }
    }
    return "";
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }


  function checkDisableOtherSrc() {
    // handle file vs url, only one type allowed
    if (quoteData.source_type === SOURCE_TYPE_VIDEO && isValidVideoSource()) {
      if (quoteData.source_files_video > 0) {
        //disable video url
        $('[data-input-url-group="video"]').addClass('disabled');
      } else {
        //disable video file
        $('[data-input-file-group="video"]').addClass('disabled');
      }
      $('[data-or="video"]').addClass('disabled');

    } else if (quoteData.source_type === SOURCE_TYPE_AUDIO && isValidAudioSource()) {
      if (quoteData.source_files_audio > 0) {
        //disable audio url
        $('[data-input-url-group="audio"]').addClass('disabled');
      } else {
        //disable audio file
        $('[data-input-file-group="audio"]').addClass('disabled');
      }
      $('[data-or="audio"]').addClass('disabled');
    } else {
      $('[data-input-url-group]').removeClass('disabled');
      $('[data-input-file-group]').removeClass('disabled');
      $('[data-or]').removeClass('disabled');
    }
  }




  function prepareQuoteData() {

    // "language_from": 77,
    // "languages_to": [81,77],
    // "services": ["transcription", "subtitling"],
    // "source_format": "video",
    // "subject_id": 2,
    // "attachment": {
    // 	"word_count": 2400,
    // 	"plain_text": "lorem ipsum dolor sit amet",
    // 	"files": [1158, 1159],
    // 	"url": ["https://youtu.be/5Peo-ivmupE", "https://youtu.be/5Peo-ivmupE2"]
    // },
    // "notes": "lorem ipsum dolor sit amet"

    var qData = {};

    qData["language_from"] = parseInt(quoteData.fromLang); // int
    qData["languages_to"] = quoteData.toLang; // Array

    if (quoteData.service.indexOf(SERVICE_SUBTITLING) < 0) {
      qData["languages_to"] = [qData["language_from"]];
    }

    qData["services"] = quoteData.service; // Array
    qData["source_format"] = quoteData.source_type; // String
    qData["subject_id"] = parseInt(quoteData.subject); //int

    // TODO set notes from textarea
    qData["notes"] = $('textarea[name="instructions"]').val();

    var attmnt = {};

    if (quoteData.uploadedFiles.length > 0) {
      var fArr = [];
      var l = quoteData.uploadedFiles.length;
      for (var i = 0; i < l; i++) {
        //log(quoteData.uploadedFiles[i]);
        fArr.push(Object.keys(quoteData.uploadedFiles[i])[0]);
      }
      attmnt['files'] = fArr;
    }

    var urls = [];
    var url;
    if (quoteData.source_type === SOURCE_TYPE_VIDEO && $.trim(quoteData.source_url_video.length) > 0) {
      url = $.trim(quoteData.source_url_video);
      if (!isValidProtocol(url)) {
        url = 'https://' + url;
      }
      urls.push(url);
    } else if (quoteData.source_type === SOURCE_TYPE_AUDIO && $.trim(quoteData.source_url_audio.length) > 0) {
      url = $.trim(quoteData.source_url_audio);
      if (!isValidProtocol(url)) {
        url = 'https://' + url;
      }
      urls.push(url);
    }

    if (urls.length > 0) {
      attmnt['url'] = urls;
    }

    qData["attachment"] = attmnt; //string
    //log('qdata');
    //log(qData);

    return qData;
  }


  function prepareOrderData() {

    //   {
    //     "confirmed": true,
    //     "instructions": "Lorem ipsum",
    //     "user_details": {
    //         "first_name": "John",
    //         "last_name": "Meyer",
    //         "email": "John.Meyer@email.com",
    //         "company": "A.C.M.E",
    //         "phone": "555 55555",
    //         "newsletter": false,
    //         "org_nr": "UEYHASM22"
    //     }
    // }
    var oData = {};

    oData["confirmed"] = 1;
    oData["instructions"] = $('form.user_details textarea[name="instructions"]').val();

    var uDetails = {};
    uDetails["first_name"] = $('form.user_details input[name="first_name"]').val();
    uDetails["last_name"] = $('form.user_details input[name="last_name"]').val();
    uDetails["email"] = $('form.user_details input[name="email"]').val();
    uDetails["company"] = $('form.user_details input[name="company"]').val();
    uDetails["phone"] = $('form.user_details input[name="phone"]').val();
    uDetails["org_nr"] = $('form.user_details input[name="org_nr"]').val();
    uDetails["newsletter"] = ($('form.user_details input[name="newsletter_signup"]').is(":checked")) ? 1 : 0;

    oData["user_details"] = uDetails;

    return oData;
  }

  function getSourceType() {
    return $('.transcription-type.tabs-panel.is-active').data('translation-type');
  }

  function isValidVideoSource() {
    if ( quoteData.source_files_video > 0 || isValidUrl(quoteData.source_url_video)) {
      return true;
    }
    return false;
  }

  function isValidAudioSource() {
    if ( quoteData.source_files_audio > 0 || isValidUrl(quoteData.source_url_audio)) {
      return true;
    }
    return false;
  }

  function isValidFileSize($file_field) {
    var max_total_files = 5;
    var files = $file_field.prop('files');
    if (files.length > 0 && files.length <= max_total_files) {
      var maxFileSize = 100 * 1024; // 100MB
      for (var i = 0; i < files.length; i++) {
        var fileSize = files.item(i).size;
        var fileSizeKb = Math.round((fileSize / 1024));
        // Check if file is too large
        if (fileSizeKb >= maxFileSize) {
          alert("Your file(s) are to heavy. A total weight of 100mb is allowed.");
          return false;
        }
      }
    } else {
      alert("Too many files. You may only upload five files.");
      return false;
    }

    return true;
  }

  function isValidUrl(str) {
    regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    if (regexp.test(str)) {
      return true;
    } else {
      return false;
    }
  }

  function isValidProtocol(link) {
    if (link.indexOf("http://") === 0 || link.indexOf("https://") === 0) {
      return true;
    }
    return false;
  }

  function formatPrice(price, currency_iso) {
    var p = price;
    $('.order-package__currency').addClass('hide');
    switch (currency_iso) {
      case "EUR":
        $('.order-package__currency.pre').removeClass('hide');
        return formatNumber(price, 0, ' ');
        break;
      case "SEK":
        $('.order-package__currency.post').removeClass('hide');
        return formatNumber(price, 0, ' ');
        break;
      case "NOK":
        $('.order-package__currency.pre').removeClass('hide');
        return formatNumber(price, 0, ' ');
        break;
      case "DKK":
        $('.order-package__currency.pre').removeClass('hide');
        return formatNumber(price, 0, '.');
        break;
      default:
        break;
    }

    return p + '';
  }

  function formatNumber(n, decPlaces, thouSeparator, decSeparator) {
    var decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
      decSeparator = decSeparator == undefined ? "." : decSeparator,
      thouSeparator = thouSeparator == undefined ? "," : thouSeparator,
      sign = n < 0 ? "-" : "",
      i = parseInt(n = Math.abs(+n || 0).toFixed(decPlaces)) + "",
      j = (j = i.length) > 3 ? j % 3 : 0;
    return sign + (j ? i.substr(0, j) + thouSeparator : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thouSeparator) + (decPlaces ? decSeparator + Math.abs(n - i).toFixed(decPlaces).slice(2) : "");
  }

  var scrollToPos = function ($pos) {
    var scrollEvents = "scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove";
    // Reset animated scroll if it's already animating
    $("html, body").stop();
    $("html, body").off(scrollEvents);

    // Scroll to position $pos
    $("html, body").on(scrollEvents, function () {
      $("html, body").stop(); // Stop scrolling if we scroll while scrollTop is animating
    });

    $("html, body").animate({ scrollTop: $pos }, 300, function () {
      $("html, body").off(scrollEvents);
    });
  };


  /*********************************
  
    Init functions
  
  *********************************/


  (function () {
    $.blockUI.defaults.css = {};
    blockUI(loader);
    apiCalls.getSubjects();
  })();
  // TODO REMOVE
  // transStates.state01.showMainForm();

  return {
    quoteData: quoteData,
    languages: languages
  };
})();
